import React, { Fragment, useEffect, useRef, useState } from "react"

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  UncontrolledTooltip,
  NavItem,
  TabContent,
  TabPane,
  CardTitle,
} from "reactstrap"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import Select from "react-select"
import SelectCreatnale from "react-select/creatable"
import Dropzone from "react-dropzone"
import {
  Link,
  NavLink,
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom"
import { connect, useDispatch, useSelector } from "react-redux"
import {
  getCitiesByCountry,
  getCountries,
} from "../../../store/address/actions"
import {
  addNewVendor,
  getVendorProfile,
  updateVendor,
} from "../../../store/vendor/actions"
import { getVendor_cats } from "../../../store/vendor_cat/actions"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
import classnames from "classnames"
import { getType_services } from "../../../store/vendor_types_services/actions"
import { getType_settings } from "../../../store/vendor_types_settings/actions"
import ReactGoogleAutocomplete from "react-google-autocomplete"
import { removeData, setData } from "../../../store/popup/actions"
import { API_KEY, colors } from "../../../helpers/color"
import { GoogleApiWrapper, Map, Marker } from "google-maps-react"
import FormEditors from "../../Forms/FormEditors"
import "react-phone-input-2/lib/bootstrap.css"
import PhoneInput from "react-phone-input-2"

const AddVendor = props => {
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams()
  const dispatch = useDispatch()
  const ref = useRef()
  const discountInputRef = useRef()
  const vendorProfile = useSelector(state => state.vendors.vendor.vendorProfile)
  const [error, setError] = useState("")
  const [selectedFiles_1, setselectedFiles_1] = useState([])
  const [longitude, setLongitude] = useState("35.502308")
  const [latitude, setLatitude] = useState("33.889716")
  const [aboutVendor, setAboutVendor] = useState("")
  const [activeTab, setactiveTab] = useState(1)
  const [vendorType, setvendorType] = useState([])
  const [TypesToRemove, setTypeTypeToRemove] = useState([])
  const [TypesToAdd, setTypeTypeToAdd] = useState([])
  const [services, setServices] = useState([])
  const [settings, setSettings] = useState([])
  const [servicesSelected, setservicesSelected] = useState([])
  const [selectedServicesToAdd, setSelectedServicesToAdd] = useState([])
  const [selectedServicesToRemove, setSelectedServicesToRemove] = useState([])

  const [coveredCountry, setCoveredCountry] = useState([])
  const [selectedCoveredCountryToAdd, setSelectedCoveredCountryToAdd] =
    useState([])
  const [selectedCoveredCountryToRemove, setSelectedCoveredCountryToRemove] =
    useState([])

  const [settingsSelected, setsettingsSelected] = useState(
    vendorProfile.settings
      ? vendorProfile.settings.map(t => ({
          label: t.setting_name_en,
          value: t.setting_id,
        }))
      : []
  )
  const [selectedSettingsToAdd, setSelectedSettingsToAdd] = useState([])
  const [selectedSettingsToRemove, setSelectedSettingsToRemove] = useState([])
  const [selectedFiles_2, setselectedFiles_2] = useState([])
  const [selectedCountry, setselectedCountry] = useState({})
  const [selectedCity, setselectedCity] = useState({})
  const [phone_code, setPhone_code] = useState("+961")
  const data = useSelector(state => state.vendors.vendortypeServices.data)
  const dataSetting = useSelector(
    state => state.vendors.vendortypeSettings.data
  )
  const coveredLocation = useSelector(state => state.popup.data)
  const countries = useSelector(state => state.address.countries)
  const vendor_cats = useSelector(
    state => state.vendors.vendor_cats.vendor_cats
  )
  const cities = useSelector(state => state.address.cities)
  useEffect(() => {
    if (vendorProfile?.vendor?.id) {
      setvendorType(
        vendorProfile.types &&
          vendorProfile?.types.map(t => ({
            label: t.cat_name_en,
            value: t.vendor_category_id,
            value_1: t.id,
          }))
      )
      setAboutVendor(vendorProfile?.vendor?.about)
      setPhone_code(vendorProfile?.vendor?.phone_code)
      setservicesSelected(
        vendorProfile?.services &&
          vendorProfile.services.map(t => ({
            label: t.service_name_en,
            value: t.service_id_base,
            value_1: t.service_id,
            vendor_type_id: t.service_type_id,
          }))
      )
      setsettingsSelected(
        vendorProfile.settings &&
          vendorProfile.settings.map(t => ({
            label: t.setting_name_en,
            value: t.setting_id,
            value_1: t.setting_selected_id,
            vendor_type_id: t.settings_type_id,
          }))
      )
      setselectedFiles_1(
        vendorProfile.vendor?.logo != null
          ? [{ preview: imageBaseUrl + vendorProfile.vendor?.logo }]
          : []
      )
      setselectedFiles_2(
        vendorProfile.vendor?.banner_img != null
          ? [{ preview: imageBaseUrl + vendorProfile.vendor?.banner_img }]
          : []
      )
      setLongitude(vendorProfile.vendor?.longitude)
      setLatitude(vendorProfile.vendor?.latitude)
      id &&
        setselectedCity({
          label:
            vendorProfile.vendor?.city_name != ""
              ? vendorProfile.vendor?.city_name
              : vendorProfile.vendor?.city__name,
          value: vendorProfile.vendor?.city_id,
        })

      id &&
        setselectedCountry({
          label: vendorProfile.vendor?.country_name,
          value: vendorProfile.vendor?.country_id,
        })
      id &&
        setCoveredCountry(
          vendorProfile.coveredLocation
            .map(vc => ({ label: vc.country_name_cov, value: vc.country_id }))
            .filter(
              (obj, index, self) =>
                index === self.findIndex(item => item.label === obj.label)
            )
        )
    }
  }, [vendorProfile])
  useEffect(() => {
    if (id) {
      dispatch(getVendorProfile(id))
    } else {
      setvendorType([])
      setservicesSelected([])
    }
  }, [id])
  useEffect(() => {
    if (id) {
      vendorType.length &&
        dispatch(
          getType_services({
            vendor_type_id: vendorType.map(v => v.value).join(","),
            is_active: 0,
          })
        )
      vendorType.length &&
        dispatch(
          getType_settings({
            vendor_type_id: vendorType.map(v => v.value).join(","),
            is_active: 0,
          })
        )
    }
  }, [vendorType])
  useEffect(() => {
    dispatch(getVendor_cats({ is_active: 1 }))
    dispatch(getCountries())
  }, [dispatch])
  useEffect(() => {
    dispatch(getCitiesByCountry(121))
  }, [])
  useEffect(() => {
    const handlegetServices = () => {
      setServices([...services, ...data])
    }
    handlegetServices()
  }, [data])
  useEffect(() => {
    const handlegetSettings = () => {
      setSettings([...settings, ...dataSetting])
    }
    handlegetSettings()
  }, [dataSetting])
  function handleAcceptedFiles_1(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles_1(files)
  }
  function handleAcceptedFiles_2(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles_2(files)
  }
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (id && vendorProfile.vendor?.name) || "",
      vendor_manager_name:
        (id && vendorProfile.vendor?.vendor_manager_name) || "",
      email: (id && vendorProfile.vendor?.email) || "",
      phone: (id && vendorProfile.vendor?.phone) || "",
      phone_secondary: (id && vendorProfile.vendor?.phone_secondary) || "",
      discount: (id && vendorProfile.vendor?.discount) || null,
      country_id: (id && vendorProfile.vendor?.country_id) || null,
      city_id: (id && vendorProfile.vendor?.city_id) || null,
      city_name: (id && vendorProfile.vendor?.city_name) || "",
      building: (id && vendorProfile.vendor?.building) || "",
      floor: (id && vendorProfile.vendor?.floor) || "",
      street: (id && vendorProfile.vendor?.street) || "",
      twitter_link: (id && vendorProfile.vendor?.twitter_link) || "",
      insta_link: (id && vendorProfile.vendor?.insta_link) || "",
      facebook_link: (id && vendorProfile.vendor?.fb_link) || "",
      logo: (id && vendorProfile.vendor?.logo) || "",
      banner_img: (id && vendorProfile.vendor?.banner_img) || "",
      description: (id && vendorProfile.vendor?.description) || "",
      address_description:
        (id && vendorProfile.vendor?.address_description) || "",
      size: (id && vendorProfile.vendor?.size) || null,
      max_capacity: (id && vendorProfile.vendor?.max_capacity) || null,
      min_price: (id && vendorProfile.vendor?.min_price) || null,
      max_price: (id && vendorProfile.vendor?.max_price) || null,
      contact_person: (id && vendorProfile.vendor?.contact_person) || "",
      youtube: (id && vendorProfile.vendor?.youtube) || null,
      website: (id && vendorProfile.vendor?.website) || null,
      tiktok: (id && vendorProfile.vendor?.tiktok) || null,
      about: (id && vendorProfile.vendor?.about) || "",
    },
    validationSchema: Yup.object({
      // name: Yup.string().required("Please Enter Your Name"),
      // email: Yup.string().required("Please Enter Your Email"),
      // phone: Yup.string().required("Please Enter Your Phone"),
      // password: Yup.string().required("Please Enter Your Password"),
      // twitter_link: Yup.string().matches(
      //   /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      //   "Enter correct link!"
      // ),
      // facebook_link: Yup.string().matches(
      //   /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      //   "Enter correct link!"
      // ),
      // insta_link: Yup.string().matches(
      //   /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      //   "Enter correct link!"
      // ),
    }),
    onSubmit: values => {
      const covered_location = coveredLocation.map(cl => ({
        name: cl.formatted_address,
        longitude: cl.longitude,
        latitude: cl.latitude,
        country_id: cl.country_id,
      }))

      let data = {
        name: values.name,
        vendor_manager_name: values.vendor_manager_name,
        email: values.email,
        password: values.password,
        phone: values.phone,
        phone_secondary: values.phone_secondary,
        contact_person: values.contact_person,
        city_id: selectedCity.__isNew__
          ? 0
          : selectedCity?.value
          ? selectedCity?.value
          : 0,
        country_id: selectedCountry.value,
        city_name: selectedCity?.label,
        building: values.building,
        floor: values.floor,
        street: values.street,
        address_description: values.address_description,
        longitude: longitude,
        latitude: latitude,
        insta_link: values.insta_link,
        fb_link: values.facebook_link,
        twitter_link: values.twitter_link,
        website: values.website,
        youtube: values.youtube,
        tiktok: values.tiktok,
        discount: values.discount
          ? values.discount > 100
            ? 100
            : values.discount
          : 0,
        min_price: values.min_price ?? 0,
        max_price: values.max_price ? values.max_price : 0,
        size: values.size ? values.size : 0,
        max_capacity: values.max_capacity ? values.max_capacity : 0,
        description: values.description,
        covered_location: JSON.stringify(covered_location),
        logo: selectedFiles_1[0],
        banner_img: selectedFiles_2[0],
        about: values.about,
        phone_code: phone_code,
      }

      if (id) {
        data.id = id
        let bool = JSON.stringify(TypesToAdd) == JSON.stringify(TypesToRemove)
        let bool1 =
          JSON.stringify(selectedServicesToAdd) ==
          JSON.stringify(selectedServicesToRemove)
        let bool2 =
          JSON.stringify(selectedSettingsToAdd) ==
          JSON.stringify(selectedSettingsToRemove)
        if (!bool) {
          data.types = JSON.stringify(TypesToAdd.map(v => v.value))
          data.types_to_remove = `${TypesToRemove.map(v => v.value).join(",")}`
        } else {
          data.types_to_remove = JSON.stringify(0)
        }
        if (!bool1) {
          data.services = JSON.stringify(
            selectedServicesToAdd.map(v => v.value)
          )
          data.services_to_remove = `${selectedServicesToRemove
            .map(v => v.value)
            .join(",")}`
        } else {
          data.services_to_remove = JSON.stringify(0)
        }
        if (!bool2) {
          data.settings = JSON.stringify(
            selectedSettingsToAdd.map(v => v.value)
          )
          data.settings_to_remove = `${selectedSettingsToRemove
            .map(v => v.value)
            .join(",")}`
        } else {
          data.settings_to_remove = JSON.stringify(0)
        }
        if (id) {
          dispatch(updateVendor(data, history))
        } else {
          window.scrollTo(0, 0)
        }
      } else {
        data.types = JSON.stringify(vendorType.map(v => v.value))
        data.services = JSON.stringify(servicesSelected.map(v => v.value))
        data.setting = JSON.stringify(settingsSelected.map(v => v.value))
        data.from_cms = 1
        dispatch(addNewVendor(data, history))
      }
    },
  })
  const countriesOptions = countries?.map(country => {
    return { label: country.name, value: country.id, iso2: country.iso2 }
  })
  const vendor_catsOptions = vendor_cats?.map(v => {
    return { label: v.cat_name_en, value: v.id }
  })
  const citiesOptions = cities?.map(city => {
    return { label: city.name, value: city.id }
  })
  function handleSelectCountry(selectedCountry) {
    _getCitiesByCountry(selectedCountry.value)
    setselectedCountry(selectedCountry)
  }
  function handleSelectCity(selectedCity) {
    setselectedCity(selectedCity)
  }
  function _getCitiesByCountry(id) {
    dispatch(getCitiesByCountry(id))
  }
  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 5) {
        setactiveTab(tab)
      }
    }
  }

  const renderSecondForm = () => {
    return (
      <Fragment>
        <div className="row">
          <div className="mb-3 col-4">
            <Label>Discount %</Label>
            <Input
              innerRef={discountInputRef}
              name="discount"
              type="number"
              min={0}
              max={100}
              placeholder="Discount"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={
                validation.values.discount > 100
                  ? 100
                  : validation.values.discount || 0
              }
              invalid={
                validation.touched.discount && validation.errors.discount
                  ? true
                  : false
              }
            />
            {validation.touched.discount && validation.errors.discount ? (
              <FormFeedback type="invalid">
                {validation.errors.discount}
              </FormFeedback>
            ) : null}
          </div>
          <div className="col-4">
            {" "}
            <Label>Minimum price</Label>
            <Input
              name="min_price"
              type="number"
              min={0}
              max={100}
              placeholder="Minimum price"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.min_price}
              invalid={
                validation.touched.min_price && validation.errors.min_price
                  ? true
                  : false
              }
            />
            {validation.touched.min_price && validation.errors.min_price ? (
              <FormFeedback type="invalid">
                {validation.errors.min_price}
              </FormFeedback>
            ) : null}
          </div>
          <div className="col-4">
            <Label>Maximum price</Label>
            <Input
              name="max_price"
              type="number"
              min={0}
              max={100}
              placeholder="Mximum price"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.max_price}
              invalid={
                validation.touched.max_price && validation.errors.max_price
                  ? true
                  : false
              }
            />
            {validation.touched.max_price && validation.errors.max_price ? (
              <FormFeedback type="invalid">
                {validation.errors.max_price}
              </FormFeedback>
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="mb-3 col-6">
            <Label>{`Square footage (m2)`}</Label>
            <Input
              name="size"
              type="number"
              min={0}
              max={100}
              placeholder="Size"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.size}
              invalid={
                validation.touched.size && validation.errors.size ? true : false
              }
            />
            {validation.touched.size && validation.errors.size ? (
              <FormFeedback type="invalid">
                {validation.errors.size}
              </FormFeedback>
            ) : null}
          </div>
          <div className="col-6">
            {" "}
            <Label>Maximum capacity</Label>
            <Input
              name="max_capacity"
              type="number"
              min={0}
              max={100}
              placeholder="Maximum capacity"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.max_capacity}
              invalid={
                validation.touched.max_capacity &&
                validation.errors.max_capacity
                  ? true
                  : false
              }
            />
            {validation.touched.max_capacity &&
            validation.errors.max_capacity ? (
              <FormFeedback type="invalid">
                {validation.errors.discount}
              </FormFeedback>
            ) : null}
          </div>
        </div>
        <div className="col-12">
          <Label>Additional information</Label>
          <Input
            name="description"
            type="text"
            placeholder="Description"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.description}
            invalid={
              validation.touched.description && validation.errors.description
                ? true
                : false
            }
          />
          {validation.touched.description && validation.errors.description ? (
            <FormFeedback type="invalid">
              {validation.errors.description}
            </FormFeedback>
          ) : null}
        </div>
        <div className="mb-3 col-6 mt-3">
          <Label className="form-label">
            Categories<Label className="text-danger ms-1">*</Label>
          </Label>
          <Select
            value={vendorType}
            onChange={(option, event) => {
              if (event?.option) {
                setTypeTypeToAdd(state => [...state, event?.option])
                dispatch(
                  getType_services({
                    vendor_type_id: event?.option?.value,
                    is_active: 0,
                  })
                )
                dispatch(
                  getType_settings({
                    vendor_type_id: event?.option?.value,
                    is_active: 0,
                  })
                )
              }

              if (event?.removedValue) {
                setTypeTypeToRemove(state => [
                  ...state,
                  {
                    value: event?.removedValue.value_1,
                  },
                ])
                setservicesSelected(
                  servicesSelected.filter(
                    s => s.vendor_type_id != event?.removedValue.value
                  )
                )
                setServices(
                  services.filter(
                    s => s.vendor_type_id != event?.removedValue.value
                  )
                )
                setSettings(
                  settings.filter(
                    s => s.vendor_type_id != event?.removedValue.value
                  )
                )
                setSelectedServicesToRemove(
                  services.filter(
                    s => s.vendor_type_id == event?.removedValue.value
                  )
                )
                setSelectedSettingsToRemove(
                  settings.filter(
                    s => s.vendor_type_id == event?.removedValue.value
                  )
                )
                setsettingsSelected(
                  settingsSelected.filter(
                    s => s.vendor_type_id == event?.removedValue.value
                  )
                )
              }
              setvendorType(option)
            }}
            isMulti={true}
            options={vendor_catsOptions}
            classNamePrefix="select2-selection"
          />
          <h4 className="card-title text-danger">{error}</h4>
        </div>
        {vendorType.map((vt, i) => (
          <div key={i + "a"} className="mb-3 col-6">
            <Label className="form-label">
              Services of {vt.label}
              <Label className="text-danger ms-1"></Label>
            </Label>
            <Select
              value={servicesSelected.filter(s => s.vendor_type_id == vt.value)}
              onChange={(option, event) => {
                if (event?.option) {
                  setSelectedServicesToAdd(state => [...state, event?.option])
                  let newOption = { ...event?.option, vendor_type_id: vt.value }
                  setservicesSelected([...servicesSelected, newOption])
                }

                if (event?.removedValue) {
                  setSelectedServicesToRemove(state => [
                    ...state,
                    {
                      value: event?.removedValue.value_1,
                    },
                  ])
                  setservicesSelected(
                    servicesSelected.filter(
                      s => s.value != event?.removedValue.value
                    )
                  )
                }
              }}
              isMulti={true}
              options={services
                .filter(s => s.vendor_type_id == vt.value)
                .map(s => ({
                  label: s.name_en,
                  value: s.id,
                  vendor_type_id: s.vendor_type_id,
                }))}
              classNamePrefix="select2-selection"
            />
            <h4 className="card-title text-danger">{error}</h4>
          </div>
        ))}

        <div className="mb-3 col-6">
          <Label className="form-label">
            service types<Label className="text-danger ms-1"></Label>
          </Label>
          <Select
            value={settingsSelected}
            onChange={(option, event) => {
              event?.option &&
                setSelectedSettingsToAdd(state => [...state, event?.option])
              event?.removedValue &&
                setSelectedSettingsToRemove(state => [
                  ...state,
                  {
                    value: event?.removedValue.value_1,
                  },
                ])
              setsettingsSelected(option)
            }}
            isMulti={true}
            options={settings.map(s => ({
              label: s.name_en_services
                ? s.name_en + ":" + s.name_en_services
                : s.name_en,
              value: s.id,
            }))}
            classNamePrefix="select2-selection"
          />
          <h4 className="card-title text-danger">{error}</h4>
        </div>
      </Fragment>
    )
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="vendors / add vendors" breadcrumbItem="" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Add new vendor</h4>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            to={{ pathname: "" }}
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                          >
                            <span className="number">1.</span> Basic information
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            to={{ pathname: "" }}
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                          >
                            <span className="number me-2">2.</span>{" "}
                            Specification
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            to={{ pathname: "" }}
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              setactiveTab(3)
                            }}
                          >
                            <span className="number me-2">3.</span> Media
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 4 })}
                        >
                          <NavLink
                            to={{ pathname: "" }}
                            className={classnames({ active: activeTab === 4 })}
                            onClick={() => {
                              setactiveTab(4)
                            }}
                          >
                            <span className="number me-2">4.</span> Covered
                            Locations
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 5 })}
                        >
                          <NavLink
                            to={{ pathname: "" }}
                            className={classnames({ active: activeTab === 5 })}
                            onClick={() => {
                              setactiveTab(5)
                            }}
                          >
                            <span className="number">5.</span> Confirm
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <div className="body">
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId={1}>
                            <Form
                              onSubmit={e => {
                                e.preventDefault()
                                validation.handleSubmit()
                                return false
                              }}
                              className="custom-validation"
                            >
                              <div className="row">
                                <div className="mb-3 col-6">
                                  <Label className="form-label">
                                    Vendor name
                                    <Label className="text-danger ms-1">
                                      *
                                    </Label>
                                  </Label>
                                  <Input
                                    name="name"
                                    placeholder="Name"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.name || ""}
                                    invalid={
                                      validation.touched.name &&
                                      validation.errors.name
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.name &&
                                  validation.errors.name ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.name}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                  <Label className="form-label">
                                    Vendor manager name
                                    <Label className="text-danger ms-1">
                                      *
                                    </Label>
                                  </Label>
                                  <Input
                                    name="vendor_manager_name"
                                    placeholder="vendor manager name"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.vendor_manager_name ||
                                      ""
                                    }
                                    invalid={
                                      validation.touched.vendor_manager_name &&
                                      validation.errors.vendor_manager_name
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.vendor_manager_name &&
                                  validation.errors.vendor_manager_name ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.vendor_manager_name}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </div>
                              <div className="row">
                                <div className="mb-3 col-6">
                                  <Label className="form-label">
                                    E-Mail
                                    <Label className="text-danger ms-1">
                                      *
                                    </Label>
                                  </Label>
                                  <Input
                                    name="email"
                                    placeholder="Enter Valid Email"
                                    type="email"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.email || ""}
                                    invalid={
                                      validation.touched.email &&
                                      validation.errors.email
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.email &&
                                  validation.errors.email ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.email}
                                    </FormFeedback>
                                  ) : null}
                                </div>

                                <div className="mb-3 col-6">
                                  <Label className="form-label">
                                    Password
                                    <Label className="text-danger ms-1">
                                      *
                                    </Label>
                                  </Label>
                                  <Input
                                    name="password"
                                    placeholder="Enter Valid Password"
                                    type="password"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.password || ""}
                                    invalid={
                                      validation.touched.password &&
                                      validation.errors.password
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.password &&
                                  validation.errors.password ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.password}
                                    </FormFeedback>
                                  ) : null}
                                </div>

                                <div className="mb-3 col-6">
                                  <Label className="form-label">
                                    Contact Person
                                    <Label className="text-danger ms-1">
                                      *
                                    </Label>
                                  </Label>
                                  <Input
                                    name="contact_person"
                                    placeholder="contact person"
                                    type="contact_person"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.contact_person || ""
                                    }
                                    invalid={
                                      validation.touched.contact_person &&
                                      validation.errors.contact_person
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.contact_person &&
                                  validation.errors.contact_person ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.contact_person}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                                <div className=" col-md-2">
                                  <Label className="form-label">
                                    Phone
                                    <Label className="text-danger ms-1">
                                      *
                                    </Label>
                                  </Label>

                                  <PhoneInput
                                    // containerStyle={{width:40}}
                                    inputStyle={{ width: "100%", height: 30 }}
                                    country={"eg"}
                                    enableSearch={true}
                                    value={phone_code}
                                    onChange={phone =>
                                      setPhone_code("+" + phone)
                                    }
                                  />
                                </div>
                                <div className="mt-2 col-md-4">
                                  <Label className="form-label">
                                    <Label className="text-danger ms-1"></Label>
                                  </Label>
                                  <Input
                                    name="phone"
                                    placeholder="Enter Valid Phone Number"
                                    type="phone"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.phone || ""}
                                    invalid={
                                      validation.touched.phone &&
                                      validation.errors.phone
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.phone &&
                                  validation.errors.phone ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.phone}
                                    </FormFeedback>
                                  ) : null}
                                </div>

                                <div className="mb-3 col-6">
                                  <Label className="form-label">
                                    Secondary phone
                                    <Label className="text-danger ms-1">
                                      *
                                    </Label>
                                  </Label>
                                  <Input
                                    name="phone_secondary"
                                    placeholder="Enter Valid secondary phone number"
                                    type="phone_secondary"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={
                                      validation.values.phone_secondary || ""
                                    }
                                    invalid={
                                      validation.touched.phone_secondary &&
                                      validation.errors.phone_secondary
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.phone_secondary &&
                                  validation.errors.phone_secondary ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.phone_secondary}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </div>

                              <Row className="mt-3">
                                <Label className="form-label">
                                  <h4>Address</h4>
                                </Label>
                                <Col xl="4">
                                  <div className="mb-3">
                                    <Label>Country</Label>
                                    <Select
                                      value={selectedCountry}
                                      onChange={option => {
                                        handleSelectCountry(option)
                                      }}
                                      options={countriesOptions}
                                      classNamePrefix="select2-selection"
                                    />
                                  </div>
                                </Col>
                                <Col md="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom04">
                                      City
                                    </Label>
                                    <SelectCreatnale
                                      value={selectedCity}
                                      onChange={option => {
                                        handleSelectCity(option)
                                      }}
                                      options={citiesOptions}
                                      classNamePrefix="select2-selection"
                                    />
                                    {validation.touched.state &&
                                    validation.errors.state ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.state}
                                      </FormFeedback>
                                    ) : null}
                                  </FormGroup>
                                </Col>
                                <Col md="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom06">
                                      Street
                                    </Label>
                                    <Input
                                      name="street"
                                      placeholder="Street"
                                      type="text"
                                      className="form-control"
                                      id="validationCustom06"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.street || ""}
                                      invalid={
                                        validation.touched.street &&
                                        validation.errors.street
                                          ? true
                                          : false
                                      }
                                    />
                                    {validation.touched.street &&
                                    validation.errors.street ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.street}
                                      </FormFeedback>
                                    ) : null}
                                  </FormGroup>
                                </Col>

                                <Col md="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom07">
                                      Building
                                    </Label>
                                    <Input
                                      name="building"
                                      placeholder="Building"
                                      type="text"
                                      className="form-control"
                                      id="validationCustom07"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.building || ""}
                                      invalid={
                                        validation.touched.building &&
                                        validation.errors.building
                                          ? true
                                          : false
                                      }
                                    />
                                    {validation.touched.building &&
                                    validation.errors.building ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.building}
                                      </FormFeedback>
                                    ) : null}
                                  </FormGroup>
                                </Col>
                                <Col md="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom010">
                                      Floor
                                    </Label>
                                    <Input
                                      name="floor"
                                      placeholder="Floor"
                                      type="text"
                                      className="form-control"
                                      id="validationCustom010"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={validation.values.floor || ""}
                                      invalid={
                                        validation.touched.floor &&
                                        validation.errors.floor
                                          ? true
                                          : false
                                      }
                                    />
                                    {validation.touched.floor &&
                                    validation.errors.floor ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.floor}
                                      </FormFeedback>
                                    ) : null}
                                  </FormGroup>
                                </Col>
                                <Col md="4">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom05">
                                      Address description
                                    </Label>
                                    <Input
                                      name="address_description"
                                      placeholder="More address description"
                                      type="text"
                                      className="form-control"
                                      id="validationCustom011"
                                      onChange={validation.handleChange}
                                      onBlur={validation.handleBlur}
                                      value={
                                        validation.values.address_description ||
                                        ""
                                      }
                                      invalid={
                                        validation.touched
                                          .address_description &&
                                        validation.errors.address_description
                                          ? true
                                          : false
                                      }
                                    />
                                    {validation.touched.address_description &&
                                    validation.errors.address_description ? (
                                      <FormFeedback type="invalid">
                                        {validation.errors.address_description}
                                      </FormFeedback>
                                    ) : null}
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Col lg={12}>
                                <Card>
                                  <CardBody>
                                    <CardTitle>Pin vendor location</CardTitle>
                                    <div
                                      id="gmaps-markers"
                                      className="gmaps"
                                      style={{ position: "relative" }}
                                    >
                                      <Map
                                        google={props.google}
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        zoom={12}
                                        onClick={(p, m, coord) => {
                                          setLatitude(coord.latLng.lat())
                                          setLongitude(coord.latLng.lng())
                                        }}
                                        initialCenter={{
                                          lat: latitude,
                                          lng: longitude,
                                        }}
                                      >
                                        <Marker
                                          title={
                                            "The marker`s title will appear as a tooltip."
                                          }
                                          name={"SOMA"}
                                          position={{
                                            lat: latitude,
                                            lng: longitude,
                                          }}
                                        />
                                      </Map>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                              <Label>
                                <h4>Social media link</h4>
                              </Label>

                              <div className="mb-3">
                                <Label>Facebook link</Label>
                                <Input
                                  name="facebook_link"
                                  type="url"
                                  placeholder="Facebook Link"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.facebook_link || ""}
                                  invalid={
                                    validation.touched.facebook_link &&
                                    validation.errors.facebook_link
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.facebook_link &&
                                validation.errors.facebook_link ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.facebook_link}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <Label>Twitter link</Label>
                                <Input
                                  name="twitter_link"
                                  type="url"
                                  placeholder="Twitter Link"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.twitter_link || ""}
                                  invalid={
                                    validation.touched.twitter_link &&
                                    validation.errors.twitter_link
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.twitter_link &&
                                validation.errors.twitter_link ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.twitter_link}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label>Instagram link</Label>
                                <Input
                                  name="insta_link"
                                  type="url"
                                  placeholder="Instagram link"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.insta_link || ""}
                                  invalid={
                                    validation.touched.insta_link &&
                                    validation.errors.insta_link
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.insta_link &&
                                validation.errors.insta_link ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.insta_link}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label>Youtube</Label>
                                <Input
                                  name="youtube"
                                  type="url"
                                  placeholder="Facebook Link"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.youtube || ""}
                                  invalid={
                                    validation.touched.youtube &&
                                    validation.errors.youtube
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.youtube &&
                                validation.errors.youtube ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.youtube}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label>Website</Label>
                                <Input
                                  name="website"
                                  type="url"
                                  placeholder="Facebook Link"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.website || ""}
                                  invalid={
                                    validation.touched.website &&
                                    validation.errors.website
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.website &&
                                validation.errors.website ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.website}
                                  </FormFeedback>
                                ) : null}
                              </div>
                              <div className="mb-3">
                                <Label>Tiktok</Label>
                                <Input
                                  name="tiktok"
                                  type="url"
                                  placeholder="Facebook Link"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.tiktok || ""}
                                  invalid={
                                    validation.touched.tiktok &&
                                    validation.errors.tiktok
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.tiktok &&
                                validation.errors.tiktok ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.tiktok}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Form>
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Form>{renderSecondForm()}</Form>
                            </div>
                          </TabPane>
                          <TabPane tabId={3}>
                            <div>
                              <Form>
                                <Label>Logo</Label>
                                <Dropzone
                                  onDrop={acceptedFiles => {
                                    handleAcceptedFiles_1(acceptedFiles)
                                  }}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone">
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                          <i className="display-4 text-muted uil uil-cloud-upload" />
                                        </div>
                                        <h4>
                                          Drop files here or click to upload.
                                        </h4>
                                      </div>
                                      <div
                                        className="dropzone-previews mt-3"
                                        id="file-previews"
                                      >
                                        {selectedFiles_1.map((f, i) => {
                                          return (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i + "-file"}
                                            >
                                              <div
                                                className="p-3"
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                <Row className="align-items-center">
                                                  <Col className="col-auto">
                                                    <img
                                                      data-dz-thumbnail=""
                                                      height="80"
                                                      className="avatar-lg rounded bg-light"
                                                      alt={f.name}
                                                      src={f.preview}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="text-muted font-weight-bold"
                                                    >
                                                      {f.name}
                                                    </Link>
                                                    <p className="mb-0">
                                                      <strong>
                                                        {f.formattedSize}
                                                      </strong>
                                                    </p>
                                                  </Col>
                                                </Row>
                                                <div
                                                  className="align-self-center"
                                                  onClick={() => {
                                                    setselectedFiles_1([])
                                                    // setVendor(prev => ({ ...prev, removeImage: 1 }))
                                                  }}
                                                >
                                                  <i
                                                    className="uil uil-trash-alt font-size-24 text-danger"
                                                    id="deletetooltip"
                                                  />
                                                  <UncontrolledTooltip
                                                    placement="top"
                                                    target="deletetooltip"
                                                  >
                                                    Delete
                                                  </UncontrolledTooltip>
                                                </div>
                                              </div>
                                            </Card>
                                          )
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                <Label>Banner</Label>
                                <Dropzone
                                  onDrop={acceptedFiles => {
                                    handleAcceptedFiles_2(acceptedFiles)
                                  }}
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone">
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                          <i className="display-4 text-muted uil uil-cloud-upload" />
                                        </div>
                                        <h4>
                                          Drop files here or click to upload.
                                        </h4>
                                      </div>
                                      <div
                                        className="dropzone-previews mt-3"
                                        id="file-previews"
                                      >
                                        {selectedFiles_2.map((f, i) => {
                                          return (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i + "-file"}
                                            >
                                              <div
                                                className="p-2"
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                <Row className="align-items-center">
                                                  <Col className="col-auto">
                                                    <img
                                                      data-dz-thumbnail=""
                                                      height="80"
                                                      className="avatar-lg rounded bg-light"
                                                      alt={f.name}
                                                      src={f.preview}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="text-muted font-weight-bold"
                                                    >
                                                      {f.name}
                                                    </Link>
                                                    <p className="mb-0">
                                                      <strong>
                                                        {f.formattedSize}
                                                      </strong>
                                                    </p>
                                                  </Col>
                                                </Row>
                                                <div
                                                  className="align-self-center"
                                                  onClick={() => {
                                                    setselectedFiles_2([])
                                                    // setVendor(prev => ({ ...prev, removeImage: 1 }))
                                                  }}
                                                >
                                                  <i
                                                    className="uil uil-trash-alt font-size-24 text-danger"
                                                    id="deletetooltip"
                                                  />
                                                  <UncontrolledTooltip
                                                    placement="top"
                                                    target="deletetooltip"
                                                  >
                                                    Delete
                                                  </UncontrolledTooltip>
                                                </div>
                                              </div>
                                            </Card>
                                          )
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                              </Form>
                            </div>
                          </TabPane>
                          <TabPane tabId={4}>
                            <div>
                              <Form>
                                <Col xl="4">
                                  <div className="mb-3">
                                    <Label>Country</Label>
                                    <Select
                                      isMulti
                                      value={coveredCountry}
                                      onChange={(option, event) => {
                                        if (event?.option) {
                                          setSelectedCoveredCountryToAdd(
                                            state => [...state, event?.option]
                                          )

                                          dispatch(
                                            setData({
                                              country_id: event?.option.value,
                                              latitude: null,
                                              longitude: null,
                                              formatted_address:
                                                "All " +
                                                event?.option.label +
                                                " cities",
                                            })
                                          )
                                        }
                                        if (event?.removedValue) {
                                          setSelectedCoveredCountryToRemove(
                                            state => [
                                              ...state,
                                              {
                                                value:
                                                  event?.removedValue.value,
                                              },
                                            ]
                                          )

                                          dispatch(
                                            removeData({
                                              country_id:
                                                event?.removedValue.value,
                                              latitude: null,
                                              longitude: null,
                                              formatted_address: null,
                                            })
                                          )
                                        }

                                        setCoveredCountry(option)
                                      }}
                                      options={countriesOptions}
                                      classNamePrefix="select2-selection"
                                    />
                                  </div>
                                </Col>
                                <div className="col-4">
                                  {coveredCountry.map(country => (
                                    <div className="mt-2">
                                      <Label>Cities of {country.label}</Label>
                                      <ReactGoogleAutocomplete
                                        // GooglePlacesDetailsQuery={{fields: 'geometry'}}

                                        ref={ref}
                                        style={{
                                          padding: 10,
                                          width: "100%",
                                          borderColor: "#d3e1f0",
                                          borderWidth: "1px",
                                          borderRadius: 4,
                                        }}
                                        apiKey={API_KEY}
                                        onPlaceSelected={place => {
                                          place.country_id = country.value
                                          place.latitude =
                                            place.geometry.location.lat()
                                          place.longitude =
                                            place.geometry.location.lng()
                                          dispatch(setData(place))
                                          ref.current.value = ""
                                        }}
                                      />
                                      {coveredLocation.filter(
                                        c =>
                                          c.country_id == country.value &&
                                          c.formatted_address
                                      ).length > 0 &&
                                        coveredLocation
                                          .filter(
                                            c => c.country_id == country.value
                                          )
                                          .map((c, i) => (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i}
                                            >
                                              <div
                                                className="p-2"
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  backgroundColor:
                                                    i % 2 == 0
                                                      ? colors.secondary
                                                      : "white",
                                                }}
                                              >
                                                <Row className="align-items-center">
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="font-weight-bold"
                                                    >
                                                      {c?.formatted_address}
                                                    </Link>
                                                  </Col>
                                                </Row>
                                                <div
                                                  className="align-self-center"
                                                  onClick={() => {
                                                    dispatch(removeData(c))
                                                    // setVendor(prev => ({ ...prev, removeImage: 1 }))
                                                  }}
                                                >
                                                  <i
                                                    className="uil uil-trash-alt font-size-24 text-danger"
                                                    id="deletetooltip"
                                                  />
                                                  <UncontrolledTooltip
                                                    placement="top"
                                                    target="deletetooltip"
                                                  >
                                                    Delete
                                                  </UncontrolledTooltip>
                                                </div>
                                              </div>
                                            </Card>
                                          ))}
                                    </div>
                                  ))}
                                </div>
                              </Form>
                            </div>
                          </TabPane>
                          <TabPane tabId={5}>
                            <div className="row justify-content-center">
                              <Col lg="12">
                                <div className="mb-3">
                                  <Label>Bio</Label>
                                  <Input
                                    name="about"
                                    type="textarea"
                                    placeholder="About"
                                    style={{ height: 400 }}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.about || ""}
                                    invalid={
                                      validation.touched.about &&
                                      validation.errors.about
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.about &&
                                  validation.errors.about ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.about}
                                    </FormFeedback>
                                  ) : null}
                                </div>
                              </Col>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab(activeTab - 1)
                            }}
                          >
                            Previous
                          </Link>
                        </li>
                        <li className={activeTab === 5 ? "submit" : "next"}>
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={() => {
                              activeTab === 5
                                ? validation.handleSubmit()
                                : toggleTab(activeTab + 1)
                            }}
                          >
                            {activeTab === 5 ? "Submit" : "Next"}
                          </Link>
                        </li>
                        {id ? (
                          <li className={activeTab === 5 ? "Submit" : "next"}>
                            <Link
                              to="#"
                              className="btn btn-primary"
                              onClick={() => {
                                validation.handleSubmit()
                              }}
                            >
                              Save
                            </Link>
                          </li>
                        ) : null}
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
const LoadingContainer = () => <div>Loading...</div>

export default connect(
  null,
  {}
)(
  GoogleApiWrapper({
    apiKey: API_KEY,
    LoadingContainer: LoadingContainer,
    v: "3",
    libraries: ["places", "visualization"],
  })(AddVendor)
)

{
  /*
 <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="vendors / add vendors" breadcrumbItem="" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row >
                    <Col xl='4'>
                        <h4 className="card-title">Add new vendor</h4>
                    </Col>
                    <Col xl="8">


                    <Button type="submit" color="danger" style={{float:'right'}} className="float-right" onClick={()=>history.push('/vendors/csv-i')}>
                        Import from CSV
                      </Button>
                  </Col>

                  </Row>
              
                  <p className="card-title-desc">
                    //  Parsley is a availity reactstrap validation. It helps you
                    // provide your users with feedback on their form submission
                    // before sending it to your server. 
                  </p>

                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    className="custom-validation"
                  >
                    <div className="mb-3">
                      <Label className="form-label">
                        Vendor name<Label className="text-danger ms-1">*</Label>
                      </Label>
                      <Input
                        name="name"
                        placeholder="Name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="row">
                      <div className="mb-3 col-6">
                        <Label className="form-label">
                          E-Mail<Label className="text-danger ms-1">*</Label>
                        </Label>
                        <Input
                          name="email"
                          placeholder="Enter Valid Email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3 col-6">
                        <Label className="form-label">
                          Phone<Label className="text-danger ms-1">*</Label>
                        </Label>
                        <Input
                          name="phone"
                          placeholder="Enter Valid Phone Number"
                          type="phone"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                          invalid={
                            validation.touched.phone && validation.errors.phone
                              ? true
                              : false
                          }
                        />
                        {validation.touched.phone && validation.errors.phone ? (
                          <FormFeedback type="invalid">
                            {validation.errors.phone}
                          </FormFeedback>
                        ) : null}
                      </div>
                    </div>
                    <div className="mb-3">
                      <Label>Vendor category</Label>
                      <Select
                        value={vendorType}
                        onChange={(option, event) => {
                          event?.option &&
                            setTypeTypeToAdd(state => [...state, event?.option])
                          event?.removedValue &&
                            setTypeTypeToRemove(state => [
                              ...state,
                              {
                                value: event?.removedValue.value_1,
                              },
                            ])
                          setvendorType(option)
                        }}
                        isMulti={true}
                        options={vendor_catsOptions}
                        classNamePrefix="select2-selection"
                      />
                      <h4 className="card-title text-danger">{error}</h4>
                    </div>
                    <Row className="mt-3">
                      <Label className="form-label">
                        <h4>Address</h4>
                      </Label>
                      <Col xl="4">
                        <div className="mb-3">
                          <Label>Country</Label>
                          <Select
                            value={selectedCountry}
                            onChange={option => {
                              handleSelectCountry(option)
                            }}
                            options={countriesOptions}
                            classNamePrefix="select2-selection"
                          />
                        </div>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom04">City</Label>
                          <SelectCreatnale
                            value={selectedCity}
                            onChange={option => {
                              handleSelectCity(option)
                            }}
                            options={citiesOptions}
                            classNamePrefix="select2-selection"
                          />
                          {validation.touched.state &&
                          validation.errors.state ? (
                            <FormFeedback type="invalid">
                              {validation.errors.state}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom05">Street</Label>
                          <Input
                            name="street"
                            placeholder="Street"
                            type="text"
                            className="form-control"
                            id="validationCustom05"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.street || ""}
                            invalid={
                              validation.touched.street &&
                              validation.errors.street
                                ? true
                                : false
                            }
                          />
                          {validation.touched.street &&
                          validation.errors.street ? (
                            <FormFeedback type="invalid">
                              {validation.errors.street}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom05">Building</Label>
                          <Input
                            name="building"
                            placeholder="Building"
                            type="text"
                            className="form-control"
                            id="validationCustom05"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.building || ""}
                            invalid={
                              validation.touched.building &&
                              validation.errors.building
                                ? true
                                : false
                            }
                          />
                          {validation.touched.building &&
                          validation.errors.building ? (
                            <FormFeedback type="invalid">
                              {validation.errors.building}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom05">Floor</Label>
                          <Input
                            name="floor"
                            placeholder="Floor"
                            type="text"
                            className="form-control"
                            id="validationCustom05"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.floor || ""}
                            invalid={
                              validation.touched.floor &&
                              validation.errors.floor
                                ? true
                                : false
                            }
                          />
                          {validation.touched.floor &&
                          validation.errors.floor ? (
                            <FormFeedback type="invalid">
                              {validation.errors.floor}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="row">
                      <div className="mb-3 col-4">
                        <Label>Discount</Label>
                        <Input
                          name="discount"
                          type="number"
                          placeholder="Discount"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.discount || 0}
                          invalid={
                            validation.touched.discount &&
                            validation.errors.discount
                              ? true
                              : false
                          }
                        />
                        {validation.touched.discount &&
                        validation.errors.discount ? (
                          <FormFeedback type="invalid">
                            {validation.errors.discount}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="col-4"></div>
                      <div className="col-4"></div>
                    </div>
                    <Label>
                      <h4>Social media link</h4>
                    </Label>

                    <div className="mb-3">
                      <Label>Facebook link</Label>
                      <Input
                        name="facebook_link"
                        type="url"
                        placeholder="Facebook Link"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.facebook_link || ""}
                        invalid={
                          validation.touched.facebook_link &&
                          validation.errors.facebook_link
                            ? true
                            : false
                        }
                      />
                      {validation.touched.facebook_link &&
                      validation.errors.facebook_link ? (
                        <FormFeedback type="invalid">
                          {validation.errors.facebook_link}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label>Twitter link</Label>
                      <Input
                        name="twitter_link"
                        type="url"
                        placeholder="Twitter Link"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.twitter_link || ""}
                        invalid={
                          validation.touched.twitter_link &&
                          validation.errors.twitter_link
                            ? true
                            : false
                        }
                      />
                      {validation.touched.twitter_link &&
                      validation.errors.twitter_link ? (
                        <FormFeedback type="invalid">
                          {validation.errors.twitter_link}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Instagram link</Label>
                      <Input
                        name="insta_link"
                        type="url"
                        placeholder="Instagram link"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.insta_link || ""}
                        invalid={
                          validation.touched.insta_link &&
                          validation.errors.insta_link
                            ? true
                            : false
                        }
                      />
                      {validation.touched.insta_link &&
                      validation.errors.insta_link ? (
                        <FormFeedback type="invalid">
                          {validation.errors.insta_link}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <Label>Logo</Label>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        handleAcceptedFiles_1(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted uil uil-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {selectedFiles_1.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div
                                    className="p-3"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-lg rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                    <div
                                      className="align-self-center"
                                      onClick={() => {
                                        setselectedFiles_1([])
                                        // setVendor(prev => ({ ...prev, removeImage: 1 }))
                                      }}
                                    >
                                      <i
                                        className="uil uil-trash-alt font-size-24 text-danger"
                                        id="deletetooltip"
                                      />
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="deletetooltip"
                                      >
                                        Delete
                                      </UncontrolledTooltip>
                                    </div>
                                  </div>
                                </Card>
                              )
                            })}
                          </div>
                        </div>
                      )}
                    </Dropzone>

                    <Label>Banner</Label>
                    <Dropzone
                      onDrop={acceptedFiles => {
                        handleAcceptedFiles_2(acceptedFiles)
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted uil uil-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                          <div
                            className="dropzone-previews mt-3"
                            id="file-previews"
                          >
                            {selectedFiles_2.map((f, i) => {
                              return (
                                <Card
                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                  key={i + "-file"}
                                >
                                  <div
                                    className="p-2"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Row className="align-items-center">
                                      <Col className="col-auto">
                                        <img
                                          data-dz-thumbnail=""
                                          height="80"
                                          className="avatar-lg rounded bg-light"
                                          alt={f.name}
                                          src={f.preview}
                                        />
                                      </Col>
                                      <Col>
                                        <Link
                                          to="#"
                                          className="text-muted font-weight-bold"
                                        >
                                          {f.name}
                                        </Link>
                                        <p className="mb-0">
                                          <strong>{f.formattedSize}</strong>
                                        </p>
                                      </Col>
                                    </Row>
                                    <div
                                      className="align-self-center"
                                      onClick={() => {
                                        setselectedFiles_2([])
                                        // setVendor(prev => ({ ...prev, removeImage: 1 }))
                                      }}
                                    >
                                      <i
                                        className="uil uil-trash-alt font-size-24 text-danger"
                                        id="deletetooltip"
                                      />
                                      <UncontrolledTooltip
                                        placement="top"
                                        target="deletetooltip"
                                      >
                                        Delete
                                      </UncontrolledTooltip>
                                    </div>
                                  </div>
                                </Card>
                              )
                            })}
                          </div>
                        </div>
                      )}
                    </Dropzone>

                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <Button type="submit" color="primary" className="">
                        Submit
                      </Button>{" "}
                      <Button type="reset" color="secondary" className="">
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
*/
}
